var _text, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector123(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_65_1",
    "data-name": "Component 65 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.17,
    height: 33.19,
    viewBox: "0 0 132.17 33.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Legal_Fuse",
    "data-name": "Legal Fuse",
    transform: "translate(41.17 21.312)",
    fill: "#021228",
    fontSize: 17,
    fontFamily: "Poppins-Black, Poppins",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Legal "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#0e71f8",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, "Fuse"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_165749",
    "data-name": "Group 165749",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117551",
    "data-name": "Path 117551",
    d: "M592.5,448.951h0a2.023,2.023,0,0,1-2.023-2.023V436.681a2.023,2.023,0,1,1,4.045,0v10.248a2.023,2.023,0,0,1-2.023,2.023",
    transform: "translate(-581.816 -428.286)",
    fill: "#0e71f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117552",
    "data-name": "Path 117552",
    d: "M1432.328,448.951h0a2.023,2.023,0,0,1-2.023-2.023V436.681a2.023,2.023,0,1,1,4.045,0v10.248a2.023,2.023,0,0,1-2.023,2.023",
    transform: "translate(-1409.336 -428.286)",
    fill: "#0e71f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117553",
    "data-name": "Path 117553",
    d: "M1013.641,20.668h0a2.023,2.023,0,0,1-2.023-2.023V2.025a2.023,2.023,0,0,1,4.046,0v16.62a2.023,2.023,0,0,1-2.023,2.023",
    transform: "translate(-996.787 -0.002)",
    fill: "#0e71f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117554",
    "data-name": "Path 117554",
    d: "M359.036,1562.828h0a2.023,2.023,0,0,1,2.023-2.023H379.57a2.023,2.023,0,0,1,0,4.046H361.059a2.023,2.023,0,0,1-2.023-2.023",
    transform: "translate(-353.772 -1537.923)",
    fill: "#021228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117555",
    "data-name": "Path 117555",
    d: "M0,1989.968H0a2.023,2.023,0,0,1,2.023-2.023H31.061a2.023,2.023,0,0,1,0,4.046H2.023A2.023,2.023,0,0,1,0,1989.968",
    transform: "translate(0 -1958.801)",
    fill: "#021228"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector123);
export default __webpack_public_path__ + "static/media/vector123.899d1cd5f40c667df0f16023cf15912e.svg";
export { ForwardRef as ReactComponent };